/*
 * Copyright Evollis 2021
 * All Rights Reserved.
 *
 * All information contained herein is, and remains the property of Evollis.
 * The intellectual and technical concepts contained herein are
 * proprietary to Evollis and are protected by trade secret and copyright law.
 * Dissemination of this information or reproduction of this material
 * is STRICTLY FORBIDDEN unless prior written permission is obtained
 * from Evollis.
 */
import React from "react"
import { OverlayTrigger, Tooltip } from "react-bootstrap"
import { isMobile } from "react-device-detect"

const DEFAULT_PLACEMENT = isMobile ? "top" : "left"

export default function InformationButton({ placement = DEFAULT_PLACEMENT, overlayText, buttonClassName }) {
  return (
    <OverlayTrigger placement={placement} overlay={<Tooltip>{overlayText}</Tooltip>}>
      <span className={`btn btn-tooltip ${buttonClassName}`} variant="light">
        <i className="fas fa-info-circle" />
      </span>
    </OverlayTrigger>
  )
}
